export class TagCategoryType {
	public id: number;
	public name: string;

	constructor(tagCategoryType: TagCategoryType) {
		Object.assign(this, tagCategoryType);
	}
}
